import { Component, AfterViewInit } from '@angular/core';
import { ListItemRendererComponent } from 'gung-list';
import { Product } from '../../../../models';
import { PlanogramAddItemsService } from '../../services/planogram-add-items.service';

@Component({
    selector: 'lib-planogram-product-grid',
    templateUrl: './planogram-product-grid.component.html',
    styleUrls: ['./planogram-product-grid.component.css'],
    standalone: false
})
export class PlanogramProductGridComponent extends ListItemRendererComponent<Product[]> implements AfterViewInit {

  constructor(protected planogramAddItemsService: PlanogramAddItemsService){
    super();
  }

  ngAfterViewInit(): void {
    this.renderFinished?.emit();
  }

  onDragStart(event, product) {
    this.planogramAddItemsService.draggedItem = product;
  }
}
